import { z } from 'zod';
export const insightKindSchema = z.enum(['LINK_SUGGESTION', 'CONTRADICTION', 'STALE_NOTE', 'ORPHAN', 'DUPLICATE', 'MONITOR_ALERT', 'RESEARCH_BRIEF', 'PATTERN']);
export const insightStatusSchema = z.enum(['NEW', 'ACCEPTED', 'DISMISSED', 'SUPERSEDED']);
export const workerKindSchema = z.enum(['reindex', 'linkSuggest', 'contradiction', 'staleReview', 'orphan', 'pattern', 'watcher', 'brief', 'digest', 'vocabulary']);
export const insightListQuerySchema = z.object({
    status: insightStatusSchema.default('NEW'),
    kind: insightKindSchema.optional(),
    limit: z.coerce.number().int().min(1).max(500).default(200),
});
export const watcherRuleSchema = z.object({
    field: z.string().min(1).max(200),
    type: z.enum(['threshold', 'delta']),
    op: z.enum(['gt', 'lt', 'gte', 'lte', 'eq', 'ne', 'changed']).optional(),
    value: z.union([z.number(), z.string(), z.boolean()]).optional(),
    deltaAbs: z.number().positive().optional(),
    window: z.number().int().min(2).max(500).default(24).optional(),
});
/** Cron with 5 fields; the scheduler validates it properly, this just keeps garbage out. */
const cronSchema = z.string().regex(/^(\S+\s+){4}\S+$/, 'cron needs 5 fields');
export const watcherCreateSchema = z.object({
    name: z.string().min(1).max(120),
    tool: z.string().min(1),
    input: z.record(z.unknown()).default({}),
    cron: cronSchema.default('0 * * * *'),
    rule: watcherRuleSchema,
    enabled: z.boolean().default(true),
    /** Create from an existing tool call: copies its tool + input. */
    fromCallId: z.string().optional(),
});
export const watcherPatchSchema = z.object({
    name: z.string().min(1).max(120).optional(),
    cron: cronSchema.optional(),
    rule: watcherRuleSchema.optional(),
    enabled: z.boolean().optional(),
    input: z.record(z.unknown()).optional(),
});
export const briefCreateSchema = z.object({
    topic: z.string().min(3).max(300),
    cron: cronSchema.default('0 6 * * 1'),
    enabled: z.boolean().default(true),
});
//# sourceMappingURL=insight.js.map